/**
 * 兼容旧路径，实际实现见 @/api/content/banner
 */
export * from "../content/banner";



// WEBPACK FOOTER //
// ./src/api/homepage/banner.js